import { useState } from 'react';
import { BotonVolver, Titulo } from '../components/ui';
import { SECCIONES } from '../ayuda/preguntas';

/**
 * Preguntas frecuentes. Plegadas: en el celular, ver solo las preguntas deja
 * encontrar la que uno busca sin scrollear un texto largo. Las respuestas y sus
 * números salen de src/ayuda/preguntas.tsx.
 */
export function Ayuda({ onVolver }: { onVolver: () => void }) {
  const [solapa, setSolapa] = useState(SECCIONES[0]!.id);
  const seccion = SECCIONES.find((s) => s.id === solapa) ?? SECCIONES[0]!;

  return (
    <div className="flex flex-col gap-4">
      <BotonVolver onClick={onVolver} />
      <Titulo>Preguntas frecuentes</Titulo>

      <nav className="flex gap-1 rounded-xl border border-(--color-borde) bg-(--color-panel) p-1">
        {SECCIONES.map((s) => (
          <button
            key={s.id}
            onClick={() => setSolapa(s.id)}
            className={`min-h-10 flex-1 rounded-lg text-sm transition
              ${
                solapa === s.id
                  ? 'bg-(--color-acento) font-semibold text-(--color-sobre-acento)'
                  : 'text-(--color-apagado)'
              }`}
          >
            {s.titulo}
          </button>
        ))}
      </nav>

      <div className="flex flex-col gap-2">
        {seccion.preguntas.map((p) => (
          <details
            key={p.pregunta}
            className="group rounded-2xl border border-(--color-borde) bg-(--color-tarjeta) px-4 py-3"
          >
            <summary className="flex cursor-pointer list-none items-center justify-between gap-3 font-semibold">
              <span>{p.pregunta}</span>
              <span className="shrink-0 text-(--color-acento) transition group-open:rotate-90" aria-hidden>
                ›
              </span>
            </summary>
            <div
              className="mt-2 flex flex-col gap-2 text-sm text-(--color-texto)/90
                [&_li]:ml-4 [&_li]:list-disc [&_ul]:flex [&_ul]:flex-col [&_ul]:gap-1"
            >
              {p.respuesta}
            </div>
          </details>
        ))}
      </div>
    </div>
  );
}
